import PushPin from '@mui/icons-material/PushPin';
import { alpha, IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface SidebarPinButtonProps {
  pinned: boolean;
  onTogglePin: () => void;
}

const SidebarPinButton = ({ pinned, onTogglePin }: SidebarPinButtonProps) => {
  const { t } = useTranslation();

  const label = pinned
    ? t('Sidebar.pinButton.unpin')
    : t('Sidebar.pinButton.pin');

  return (
    <Tooltip title={label}>
      <IconButton
        data-testid="SidebarPinButton.IconButton"
        onClick={onTogglePin}
        size="small"
        aria-label={label}
        sx={theme => ({
          color: alpha(theme.palette.common.white, 0.7),
          '&:hover': {
            color: theme.palette.common.white,
            backgroundColor: alpha(theme.palette.common.white, 0.12),
          },
        })}
      >
        <PushPin
          fontSize="small"
          sx={{
            transform: pinned ? 'rotate(0deg)' : 'rotate(45deg)',
            transition: 'transform 225ms ease',
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default SidebarPinButton;
